<template>
<div id="OfferStats" class="vs-con-loading__container">
    <h4 class="card-title d-flex">{{$t('DASHBOARD.OFFER_STATS')}}
      <div class="ml-auto text-right">
        <vs-button  @click="LoadData()" size="small" color="primary" type="filled" icon="refresh"></vs-button>
      </div>
    </h4>   
   <PieChart ref="offerpiechart" :height="300" :chartid="'offerstatsPieChart'"></PieChart>
</div>
</template>
<script>
import PieChart from '../Charts/PieChart.vue';
import codeHelper from '../../../helper/staticCodeHelper';

export default {
  name: "OfferPieChart",
  props:[],
  components:{PieChart},
  data: function (){
     return {
       offerstats:{},
       loading:false
     }
  }, 
  mounted () {
    this.LoadData();
    
  },
  methods:{
    ...codeHelper,
    LoadData(){
      this.loading = true;
      this.$store.dispatch('accounting/getOfferStats',{ root: true },{ root: true })
       .then(response => {
          this.loading = false;
          if(this.IsNotNull(response))
          {
            this.offerstats = response;
            var series= [
              this.offerstats.created,
              this.offerstats.inwork,
              this.offerstats.waiting,
              this.offerstats.ordered,
              this.offerstats.confirmed,
              this.offerstats.rejected
              ];
            
            this.$refs.offerpiechart.setSeries(series);

            var labels = [
              this.offerstats.created_label,
              this.offerstats.inwork_label,
              this.offerstats.waiting_label,
              this.offerstats.ordered_label,
              this.offerstats.confirmed_label,
              this.offerstats.rejected_label
              ];

            this.$refs.offerpiechart.setLabels(labels);
          }
          else
          {
            this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':this.$t('DASHBOARD.OFFERSTATS.ERROR.LOAD')});
          }
          
        }, 
        error =>{
          this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':this.$t('DASHBOARD.OFFERSTATS.ERROR.LOAD')+' '+error});
        }); 
    },
  },
  computed:{
   
  },
  watch:{
    loading(value)
    {
      if(value)
      {
        this.$store.dispatch('alertqueue/showLoader', {'id':'#OfferStats'});
      }
      else
      {
        this.$store.dispatch('alertqueue/hideLoader', {'id':'#OfferStats'});
      }
    }   
  }
};
</script>